const api = {
    tokenPrices: '/api/v1/price/all',
};

export default api;
